import { colors } from "./colors";
import { Habit } from "./types";

export function getDayColor(habits: Habit[], score: number, habitCount: number) {
  const maxPositiveScore = habits.reduce(
    (total, habit) => total + (habit.score > 0 ? habit.score : 0),
    0
  );
  const maxNegativeScore = habits.reduce(
    (total, habit) => total + (habit.score < 0 ? habit.score : 0),
    0
  );

  if (score > 0) {
    if (score <= maxPositiveScore / 5) return colors.green.lightest;
    if (score <= (2 * maxPositiveScore) / 5) return colors.green.light;
    if (score <= (3 * maxPositiveScore) / 5) return colors.green.medium;
    if (score <= (4 * maxPositiveScore) / 5) return colors.green.dark;
    return colors.green.darkest;
  }
  if (score < 0) {
    if (score >= maxNegativeScore / 5) return colors.red.lightest;
    if (score >= (2 * maxNegativeScore) / 5) return colors.red.light;
    if (score >= (3 * maxNegativeScore) / 5) return colors.red.medium;
    if (score >= (4 * maxNegativeScore) / 5) return colors.red.dark;
    return colors.red.darkest;
  }
  return "transparent";
}